import $ from 'jquery';
import fullpage from 'fullpage.js';
import AOS from 'aos';
import 'aos/dist/aos.css';

const aosAnim = (() => {
  const fullpageJs = () => {
    if ($('#homeAnimPage').is(":visible")){
      var fullPageInstance = new fullpage('#homeAnimPage', {
        normalScrollElements: true,
        offsetSectionsKey: 'Y29kZXBlbi5pb196MDZiMlptYzJWMFUyVmpkR2x2Ym5NPWhPNA==',
        fitToSection:false,
        scrollBar: true,
        responsiveWidth: 992,
        normalScrollElements: '.scrollable-content',
        scrollOverflow:true,
        css3: true,
        scrollingSpeed: 1500,
        // paddingTop: '100px',
        afterRender: function(origin, destination, direction, trigger){
          if (this.index == 0) {
            $(".arrow-down-section1").on("click", function(){
              fullpage_api.moveTo(2);
            });
          }
        },
        onLeave: function (origin, destination, direction) {
          if (destination.index < 1) {
            $(".page-to-up").removeClass("active");
            $(".arrow-down-section1").on("click", function(){
              fullpage_api.moveTo(2);
            });
          }
          if (destination.index >= 1) {
            $(".page-to-up").addClass("active").on("click", function(){
              fullpage_api.moveTo(0);
            });
            $(".arrow-down-section2").on("click", function(){
              fullpage_api.moveTo(3);
            });
          }
          if (destination.index >= 2) {
            $(".arrow-down-section3").on("click", function(){
              fullpage_api.moveTo(4);
            });
          }
          if (destination.index >= 3) {
            $(".arrow-down-section4").on("click", function(){
              fullpage_api.moveTo(5);
            });
          }
          if (destination.index >= 4) {
            setTimeout(function () {
              $(".home-career").addClass("pos-active");
            }, 500);
          }
        },
        afterLoad: function(){       
          $('.aos-init').addClass('aos-animate'); 
        }
      });
      fullPageInstance.reBuild();
    }
  }

  const defaultAos = () => {
    AOS.init();
  };


  const init = () => {
    defaultAos();
    fullpageJs();
  };

  return {
    init,
  };
})();

export default aosAnim;
